import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

const SidebarPost = ({ data, path }) => {
    const getRandomObject = (array) => {
        const randomObject = array[Math.floor(Math.random() * array.length)];
        return randomObject;
    };

    const randomData = Math.floor(Math.random() * 7) + 1; //Math.floor(Math.random() * data.length);
    console.log("randomData" + randomData);

    return (
        <div className="widget-post-wrap">
            {data.slice(randomData, randomData + 3).map((single, i) => {
                return (
                    <div key={i} className="widget-post-list">
                        <Link
                            to={process.env.PUBLIC_URL + path + single.id}
                            className="post-thumb"
                        >
                            <img
                                src={`${process.env.PUBLIC_URL}/${single.media.rcImage}`}
                                alt=""
                                width="70"
                            />
                        </Link>
                        <div className="widget-post-content">
                            <h3 className="widget-sub-title">
                                <Link
                                    to={
                                        process.env.PUBLIC_URL +
                                        path +
                                        single.id
                                    }
                                >
                                    {single.title.slice(0, 35)} ...
                                </Link>
                            </h3>
                            <p className="post-meta">{single.date}</p>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

SidebarPost.propTypes = {
    data: PropTypes.array,
    path: PropTypes.string,
};

export default SidebarPost;
